module.exports = __webpack_public_path__ + "resources/img/bg_cover_tcc_m.dd57fe832665a32bbaf613305a175cd3.jpg";